import React, { useState, useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Portal from '@material-ui/core/Portal'
import Alert from 'react-s-alert'

// CORE UI (CSS mantido; JS do CoreUI removido — manipulava o DOM e quebrava o layout customizado)
import '../node_modules/jquery/dist/jquery'
import '../node_modules/popper.js/dist/umd/popper.min'
import '../node_modules/bootstrap/dist/js/bootstrap.min'
import '../node_modules/perfect-scrollbar/dist/perfect-scrollbar'
import '../node_modules/@coreui/coreui/dist/css/coreui.min.css'

import './css/default.css'
import './css/veiculo.css'
import '../node_modules/material-design-icons/iconfont/material-icons.css'

import '../node_modules/react-s-alert/dist/s-alert-default.css'
import '../node_modules/react-s-alert/dist/s-alert-css-effects/slide.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import './css/components/calendario.css'
import './css/components/nota-fiscal-cte-os.css'
import './css/components/damdfe.css'
import './css/components/novo-layout.css'

import AppRoutes from './routes/AppRoutes'
import Template from './componentes/layout/Template'
import Sidebar from './componentes/layout/Sidebar'
import Loading from './componentes/layout/Loading'
import MessagesBar from './componentes/MessagesBar'
import VerificadorVersao from './componentes/VerificadorVersao'

import { registerLocale, setDefaultLocale } from 'react-datepicker'
import 'moment/locale/pt-br'
import pt from 'date-fns/locale/pt'

registerLocale('pt', pt)
setDefaultLocale('pt')

const SIDEBAR_WIDTH = 240

const AppBase = ({ isAuthenticated }) => {
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth > 768)

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth <= 768) setSidebarOpen(false)
      else setSidebarOpen(true)
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const toggleSidebar = () => setSidebarOpen(p => !p)
  const closeSidebar  = () => setSidebarOpen(false)

  return (
    <BrowserRouter>
      <React.Fragment>
        <VerificadorVersao />
        <Loading />

        {isAuthenticated ? (
          <div
            className="vx-shell"
            style={{ paddingLeft: sidebarOpen ? SIDEBAR_WIDTH : 0 }}
          >
            <Sidebar isOpen={sidebarOpen} onClose={closeSidebar} />

            <div className="vx-content-wrapper">
              <Template onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />

              <main className="vx-main">
                <div className="container-fluid">
                  <div className="animated fadeIn">
                    <AppRoutes />
                  </div>
                </div>
                <Portal>
                  <MessagesBar />
                </Portal>
              </main>
            </div>
          </div>
        ) : (
          <div className="app-body" style={{ height: '100%' }}>
            <main className="main">
              <div className="container-fluid">
                <div className="animated fadeIn">
                  <AppRoutes />
                </div>
              </div>
              <Portal>
                <MessagesBar />
              </Portal>
            </main>
          </div>
        )}

        <Alert stack={{ limit: 2, spacing: 10 }} />
      </React.Fragment>
    </BrowserRouter>
  )
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.authentication && state.authentication.isAuthenticated
})

// index.js importa { App } (named export) — precisa ser o componente conectado ao Redux
export const App = connect(mapStateToProps)(AppBase)
export default App
